import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Checkbox,
	Button,
	notification,
	Tag,
	Input,
	Modal,
	Carousel,
	Form,
	Row,
	Col,
	Upload,
	Tooltip,
} from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import {
	EditFilled,
	EyeFilled,
	FilePdfOutlined,
	LeftOutlined,
	MailOutlined,
	PlusOutlined,
	RetweetOutlined,
	RightOutlined,
	RollbackOutlined,
	UploadOutlined,
} from "@ant-design/icons";
import QAQCFieldReportAddEticketValuesModal from "./QAQCFieldReportAddEticketValuesModal";
const { Text } = Typography;

const QAQCFieldReports = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobList, setJobList] = useState([]);
	// const [qcUserList, setQCUserList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const [apiNotification, contextHolder] = notification.useNotification();

	const [notesModalOpen, setNotesModalOpen] = useState(false);
	const [imagesModalOpen, setImagesModalOpen] = useState(false);
	const [openModalSend, setOpenModalSend] = useState(false);

	const [editingJobId, setEditingJobId] = useState(null);
	const [selectedJob, setSelectedJob] = useState(null);

	const [carouselImages, setCarouselImages] = useState([]);
	const [form] = Form.useForm();

	const [uploadModalOpen, setUploadModalOpen] = useState(false);
	const [eticketModalOpen, setEticketModalOpen] = useState(false);
	const [uploadFileList, setUploadFileList] = useState([]);
	const [uploadForm] = Form.useForm();
	const [emailForm] = Form.useForm();

	const [refresh, setRefresh] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Job Number",
			dataIndex: "number",
			key: "number",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "scheduledDate",
			key: "scheduledDate",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "QC Type",
			dataIndex: "qcType",
			key: "qcType",
			render: (value) => {
				return (
					<Tag color={value === "Internal" ? "purple" : "yellow"}>{value}</Tag>
				);
			},
		},
		{
			title: "QC Name",
			dataIndex: "qcName",
			key: "qcName",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "QC Technician",
			dataIndex: "qcTechnical",
			key: "qcTechnical",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "QC Internal Type",
			dataIndex: "qcInternalType",
			key: "qcInternalType",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Previous Pour Tasks",
			dataIndex: "prePourComplete",
			key: "prePourComplete",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Made By User",
			dataIndex: "prePourUser",
			key: "prePourUser",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck Loads & Testing",
			dataIndex: "pourTestingComplete",
			key: "pourTestingComplete",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Made By User",
			dataIndex: "pourTestingUser",
			key: "pourTestingUser",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "After Pour Tasks",
			dataIndex: "afterPourComplete",
			key: "afterPourComplete",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Made By User",
			dataIndex: "afterPourUser",
			key: "afterPourUser",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Extra Notes",
			dataIndex: "extraNotes",
			key: "extraNotes",
			render: (value, record) => {
				return (
					<Flex gap={8} align="center">
						<Text style={{ whiteSpace: "pre-line", flex: 1 }}>{value}</Text>

						<Button
							type="primary"
							size="small"
							icon={<EditFilled />}
							onClick={() => {
								form.setFieldsValue({ extraNotes: value });
								setEditingJobId(record.id);
								setNotesModalOpen(true);
							}}
							disabled={record.isUploadDisabled}
						/>
					</Flex>
				);
			},
			width: 200,
		},
		{
			title: "Extra Images",
			dataIndex: "extraImages",
			key: "extraImages",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<UploadOutlined />}
							onClick={() => {
								setEditingJobId(record.id);
								setUploadModalOpen(true);
							}}
							disabled={record.isUploadDisabled}
						>
							Upload
						</Button>
					</Col>
					{value?.length > 0 && (
						<Col>
							<Button
								type="primary"
								size="small"
								onClick={() => {
									setCarouselImages(value);
									setImagesModalOpen(true);
								}}
								icon={<EyeFilled />}
							>
								Images ({value.length})
							</Button>
						</Col>
					)}
				</Row>
			),
		},
		// {
		// 	title: "Assign QC User",
		// 	dataIndex: "qcUser",
		// 	key: "qcUser",
		// 	render: (value, record) => {
		// 		return (
		// 			<Select
		// 				style={{ width: 150 }}
		// 				options={qcUserList}
		// 				value={value === "-" ? undefined : value}
		// 				placeholder="Select QC"
		// 				onChange={(val) => updateQCUser(record.id, val)}
		// 			/>
		// 		);
		// 	},
		// },
		{
			title: "Ambient Conditions",
			dataIndex: "ambientConditions",
			key: "ambientConditions",
			render: (value, record) => (
				<Row gutter={[16, 16]}>
					<Col>
						<Button
							type="default"
							size="small"
							icon={<PlusOutlined />}
							onClick={() => {
								setSelectedJob(record);
								setEticketModalOpen(true);
							}}
							disabled={record.hasAllValuesOfEticket}
						>
							Add Values
						</Button>
					</Col>
				</Row>
			),
		},
		{
			title: "Franchise",
			dataIndex: "franchise",
			key: "franchise",
			render: (value) => {
				return (
					<Tag
						color={
							value === "57Concrete"
								? "blue"
								: value === "Castle"
									? "green"
									: "cyan"
						}
					>
						{value}
					</Tag>
				);
			},
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => {
				const isDisabled =
					!record.prePourComplete ||
					!record.pourTestingComplete ||
					!record.afterPourComplete ||
					!record.hasAllValuesOfEticket;
				return (
					<Row gutter={[16, 16]}>
						<Col span={12}>
							<Tooltip title="Generate PDF">
								<Button
									type="primary"
									size="small"
									icon={<FilePdfOutlined />}
									onClick={() => {
										history.push(`/qc/job/fieldreports/pdf/${record.id}`);
									}}
									disabled={isDisabled}
								/>
							</Tooltip>
						</Col>
						<Col span={12}>
							<Tooltip title="Send Email">
								<Button
									type="primary"
									size="small"
									icon={<MailOutlined />}
									onClick={() => {
										setEditingJobId(record.id);
										setOpenModalSend(true);
									}}
									disabled={isDisabled}
								/>
							</Tooltip>
						</Col>
					</Row>
				);
			},
		},
	];

	const updateQCUser = async (jobId, qcUser) => {
		try {
			setLoadingTable(true);
			const url = api + `/job/${jobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			await axios.patch(url, { qcUser });
			openNotification("success", "Updated", "QC User updated successfully");
			setJobList((prev) =>
				prev.map((job) => (job.id === jobId ? { ...job, qcUser } : job)),
			);
			setLoadingTable(false);
		} catch (err) {
			console.error(err);
			openNotification("error", "Error", err.message);
		}
	};

	useEffect(() => {
		// getQCUserList();
		getJobList();
	}, [startDate, endDate, refresh]);

	const getJobList = async () => {
		try {
			setLoading(true);
			setLoadingTable(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url = api + `/job/get/qc/list?startDate=${start}&endDate=${end}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						number: item.number,
						qcType: item.qcType ?? "-",
						qcName: item.qcName ?? "-",
						qcTechnical: item.qcTechnical ?? "-",
						qcInternalType: item.qcInternalType ?? "-",
						franchise: item.franchise || "57Concrete",
						prePourComplete: item.qcData ? item.qcData.prePourComplete : false,
						pourTestingComplete: item.qcData
							? item.qcData.pourTestingComplete
							: false,
						afterPourComplete: item.qcData
							? item.qcData.afterPourComplete
							: false,
						customer: item.customer.name,
						seller: item.seller.name,
						prePourUser: item.qcData
							? item.qcData.prePourUser
								? item.qcData.prePourUser.name
								: "-"
							: "-",
						pourTestingUser: item.qcData
							? item.qcData.pourTestingUser
								? item.qcData.pourTestingUser.name
								: "-"
							: "-",
						afterPourUser: item.qcData
							? item.qcData.afterPourUser
								? item.qcData.afterPourUser.name
								: "-"
							: "-",
						extraNotes: item.qcData ? (item.qcData.extraNotes ?? "") : "",
						extraImages: item.qcData ? (item.qcData.extraImages ?? []) : [],
						// qcUser: item.qcUser,
						scheduledDate: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
						isUploadDisabled:
							item.qcData && item.qcData.qcFieldReportUrl === undefined
								? false
								: true,
						hasAllValuesOfEticket: item.hasAllValuesOfEticket,
					});
				});
				setJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<CustomTable columns={columns} data={jobList} loading={loadingTable} />
				<RenderExtraNotesModal />
				<RenderImagesCarousel />
			</Flex>
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const RenderSearch = () => (
		<Flex gap={10} align="end" justify="space-between">
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				onRangeChange={onRangeChange}
				dateFormat={"MM/DD/YYYY"}
			/>
			<Button
				type="primary"
				onClick={() => setRefresh((prev) => !prev)}
				icon={<RetweetOutlined />}
				size="large"
				loading={loading}
			/>
		</Flex>
	);

	const goBack = () => {
		history.goBack();
	};

	const handleSaveNotes = async (id, extraNotes) => {
		try {
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = {
				Authorization: `Bearer ${token}`,
			};

			await axios.post(`${api}/job/add/qc/extrafiles/${id}`, {
				extraNotes: extraNotes,
			});

			openNotification("success", "Updated", "Extra notes updated");

			setJobList((prev) =>
				prev.map((job) =>
					job.id === id ? { ...job, extraNotes: extraNotes } : job,
				),
			);

			setNotesModalOpen(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
		}
	};

	const handleUploadImages = async () => {
		try {
			if (!uploadFileList.length) {
				openNotification("error", "No files", "Please select images");
				return;
			}

			const formData = new FormData();

			const countImages =
				jobList.find((job) => job.id === editingJobId)?.extraImages?.length ||
				0;

			uploadFileList.forEach((file, index) => {
				const renamedFile = new File(
					[file.originFileObj],
					`extra_${countImages + index + 1}.${file.originFileObj.type.split("/")[1]}`,
					{
						type: file.originFileObj.type,
					},
				);
				formData.append("extraImages", renamedFile);
			});

			const url = api + `/job/add/qc/extrafiles/${editingJobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Uploaded", "Images uploaded");
				setJobList((prev) =>
					prev.map((job) =>
						job.id === editingJobId
							? { ...job, extraImages: data.payload.qcData.extraImages }
							: job,
					),
				);
			} else {
				openNotification("error", "Error", data.message);
			}

			setUploadModalOpen(false);
			setUploadFileList([]);
			uploadForm.resetFields();
		} catch (err) {
			openNotification("error", "Error", err.message);
		}
	};

	const handleUploadChange = (info) => {
		setUploadFileList(info.fileList);
	};

	const RenderUploadImagesModal = useMemo(
		() => (
			<Modal
				title="Upload Extra Images"
				open={uploadModalOpen}
				onCancel={() => {
					setUploadModalOpen(false);
					setUploadFileList([]);
					uploadForm.resetFields();
				}}
				onOk={() => uploadForm.submit()}
				destroyOnClose
				forceRender
				centered
			>
				<Form form={uploadForm} layout="vertical" onFinish={handleUploadImages}>
					<Form.Item
						label="Extra Images"
						required
						rules={[{ required: true, message: "Please select images" }]}
						getValueFromEvent={(e) => {
							if (Array.isArray(e)) return e;
							return e?.fileList;
						}}
					>
						<Upload
							listType="picture-card"
							multiple
							fileList={uploadFileList}
							beforeUpload={() => false}
							onChange={handleUploadChange}
							accept=".png, .jpg, .jpeg"
							showUploadList={{ showPreviewIcon: false }}
						>
							<PlusOutlined />
						</Upload>
					</Form.Item>
				</Form>
			</Modal>
		),
		[uploadModalOpen, uploadFileList],
	);

	const handleSendByEmail = async (values) => {
		try {
			setLoadingTable(true);
			const url = api + `/job/get/qc/fieldreport/email/${editingJobId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, {
				destination: values.email,
			});
			if (data.success) {
				openNotification("success", "Success", "Email Sent");
				setLoadingTable(false);
			} else {
				openNotification("error", "Error", data.message);
				setLoadingTable(false);
			}

			setOpenModalSend(false);
			emailForm.resetFields();
		} catch (err) {
			openNotification("error", "Error", err.message);
		}
	};

	const RenderEmailModal = useMemo(
		() => (
			<Modal
				title="Send PDF via email"
				open={openModalSend}
				onCancel={() => {
					setOpenModalSend(false);
					emailForm.resetFields();
				}}
				onOk={() => emailForm.submit()}
				destroyOnClose
				forceRender
				centered
			>
				<Form form={emailForm} layout="vertical" onFinish={handleSendByEmail}>
					<Form.Item
						label="Email"
						name="email"
						required
						rules={[
							{ required: true, message: "Please fill email" },
							{ type: "email", message: "Invalid email format" },
						]}
					>
						<Input size="large" />
					</Form.Item>
				</Form>
			</Modal>
		),
		[openModalSend],
	);

	const RenderExtraNotesModal = () => {
		return (
			<Modal
				title="Edit Extra Notes"
				open={notesModalOpen}
				onCancel={() => setNotesModalOpen(false)}
				onOk={() => {
					form.submit();
				}}
				centered
			>
				<Form
					form={form}
					layout="vertical"
					onFinish={(values) => {
						handleSaveNotes(editingJobId, values.extraNotes);
						setNotesModalOpen(false);
					}}
				>
					<Form.Item
						label="Extra Notes"
						name="extraNotes"
						rules={[{ max: 1000, message: "Max 1000 characters" }]}
					>
						<Input.TextArea
							rows={6}
							placeholder="Write extra notes here..."
							showCount
							autoFocus
						/>
					</Form.Item>
				</Form>
			</Modal>
		);
	};

	const PrevArrow = ({ onClick }) => (
		<LeftOutlined
			onClick={onClick}
			style={{
				position: "absolute",
				left: 10,
				top: "50%",
				transform: "translateY(-50%)",
				fontSize: 24,
				color: "#000",
				cursor: "pointer",
				zIndex: 2,
			}}
		/>
	);

	const NextArrow = ({ onClick }) => (
		<RightOutlined
			onClick={onClick}
			style={{
				position: "absolute",
				right: 10,
				top: "50%",
				transform: "translateY(-50%)",
				fontSize: 24,
				color: "#000",
				cursor: "pointer",
				zIndex: 2,
			}}
		/>
	);

	const RenderImagesCarousel = () => {
		return (
			<Modal
				title="Extra Images"
				open={imagesModalOpen}
				footer={null}
				onCancel={() => setImagesModalOpen(false)}
				width={800}
			>
				<Carousel arrows prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
					{carouselImages.map((img, index) => (
						<div key={index}>
							<img
								src={img}
								alt={`extra-${index}`}
								style={{
									width: "100%",
									maxHeight: 500,
									objectFit: "contain",
								}}
							/>
						</div>
					))}
				</Carousel>
			</Modal>
		);
	};

	const onCloseModal = (currentJob, hasAllValuesOfEticket) => {
		setLoadingTable(true);

		setJobList((prev) =>
			prev.map((job) =>
				job.id === currentJob.id ? { ...job, hasAllValuesOfEticket } : job,
			),
		);

		setLoadingTable(false);
	};

	return (
		<Layout title="QA/QC" description="Field Reports">
			<Flex vertical gap={16}>
				<Button
					type="primary"
					size="large"
					icon={<RollbackOutlined />}
					onClick={goBack}
					loading={loading}
					disabled={loading}
				/>
				<RenderSearch />
				{RenderUploadImagesModal}
				{RenderEmailModal}
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
				<QAQCFieldReportAddEticketValuesModal
					eticketModalOpen={eticketModalOpen}
					setEticketModalOpen={setEticketModalOpen}
					selectedJob={selectedJob}
					setSelectedJob={setSelectedJob}
					onCloseModal={onCloseModal}
				/>
			</Flex>
		</Layout>
	);
};

export default QAQCFieldReports;
